export const ru = {
    'image-preview-header': 'Предпросмотр изображения',
    'image-preview-header-with-name': 'Предпросмотр изображения «{name}»',
    'selected-categories-count': {
        one: 'Выбрана {count} тематика',
        some: 'Выбрано {count} тематики',
        many: 'Выбрано {count} тематик',
        none: 'Выбор тематик'
    },
    title: 'Библиотека изображений'
};
